// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__nxvmw","header":"PageNotFound_header__+lCvI","text":"PageNotFound_text__bbsY7"};